import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Card, Button, Typography, Space, Alert, Descriptions } from 'antd';
import keycloakService from '../services/KeycloakService';
import { useApi } from 'sysone-api-mapper';
const { Title, Text, Paragraph } = Typography;
const KeycloakTestPage = () => {
    const [keycloakState, setKeycloakState] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const api = useApi();
    useEffect(() => {
        const testKeycloak = async () => {
            try {
                setLoading(true);
                console.log('🧪 Iniciando test de Keycloak...');
                const authenticated = await keycloakService.initialize();
                const state = {
                    authenticated,
                    isAuthenticated: keycloakService.isAuthenticated(),
                    token: keycloakService.getToken(),
                    refreshToken: keycloakService.getRefreshToken(),
                    userInfo: null,
                };
                if (authenticated) {
                    try {
                        state.userInfo = await keycloakService.getUserInfo();
                    }
                    catch (userError) {
                        console.error('Error obteniendo usuario:', userError);
                    }
                }
                setKeycloakState(state);
                console.log('🧪 Estado de Keycloak:', state);
            }
            catch (err) {
                console.error('Error en test:', err);
                setError(err instanceof Error ? err.message : 'Error desconocido');
            }
            finally {
                setLoading(false);
            }
        };
        testKeycloak();
    }, []);
    const handleLogin = async () => {
        try {
            await keycloakService.login();
        }
        catch (err) {
            setError(err instanceof Error ? err.message : 'Error en login');
        }
    };
    const handleLogout = async () => {
        try {
            await keycloakService.logout();
        }
        catch (err) {
            setError(err instanceof Error ? err.message : 'Error en logout');
        }
    };
    if (loading) {
        return (_jsx("div", { style: { padding: '24px' }, children: _jsx(Card, { children: _jsx(Text, { children: "Cargando test de Keycloak..." }) }) }));
    }
    return (_jsx("div", { style: { padding: '24px' }, children: _jsxs(Space, { direction: "vertical", size: "large", style: { width: '100%' }, children: [_jsxs(Card, { children: [_jsx(Title, { level: 2, children: "\uD83E\uDDEA Test de Keycloak" }), _jsx(Paragraph, { children: "Esta p\u00E1gina muestra el estado actual de Keycloak para debugging." })] }), error && (_jsx(Alert, { message: "Error", description: error, type: "error", showIcon: true, closable: true, onClose: () => setError(null) })), _jsx(Card, { title: "Estado de Autenticaci\u00F3n", children: _jsxs(Descriptions, { column: 1, bordered: true, children: [_jsx(Descriptions.Item, { label: "Autenticado (init)", children: keycloakState?.authenticated ? '✅ Sí' : '❌ No' }), _jsx(Descriptions.Item, { label: "Autenticado (service)", children: keycloakState?.isAuthenticated ? '✅ Sí' : '❌ No' }), _jsx(Descriptions.Item, { label: "Tiene Token", children: keycloakState?.token ? '✅ Sí' : '❌ No' }), _jsx(Descriptions.Item, { label: "Tiene Refresh Token", children: keycloakState?.refreshToken ? '✅ Sí' : '❌ No' }), _jsx(Descriptions.Item, { label: "Informaci\u00F3n de Usuario", children: keycloakState?.userInfo ? '✅ Cargada' : '❌ No disponible' })] }) }), keycloakState?.userInfo && (_jsx(Card, { title: "Informaci\u00F3n del Usuario", children: _jsxs(Descriptions, { column: 1, bordered: true, children: [_jsx(Descriptions.Item, { label: "ID", children: keycloakState.userInfo.id }), _jsx(Descriptions.Item, { label: "Username", children: keycloakState.userInfo.username }), _jsx(Descriptions.Item, { label: "Email", children: keycloakState.userInfo.email }), _jsx(Descriptions.Item, { label: "Nombre", children: keycloakState.userInfo.name }), _jsx(Descriptions.Item, { label: "Roles", children: keycloakState.userInfo.roles?.join(', ') || 'Sin roles' }), _jsx(Descriptions.Item, { label: "Permisos", children: keycloakState.userInfo.permissions?.join(', ') || 'Sin permisos' })] }) })), keycloakState?.token && (_jsx(Card, { title: "Token (primeros 100 caracteres)", children: _jsxs(Text, { code: true, style: { wordBreak: 'break-all' }, children: [keycloakState.token.substring(0, 100), "..."] }) })), _jsx(Card, { title: "Acciones", children: _jsxs(Space, { children: [_jsx(Button, { type: "primary", onClick: handleLogin, children: "Hacer Login" }), _jsx(Button, { onClick: handleLogout, children: "Hacer Logout" }), _jsx(Button, { onClick: () => window.location.reload(), children: "Recargar P\u00E1gina" })] }) }), _jsx(Card, { title: "Informaci\u00F3n de Debug", children: _jsxs(Descriptions, { column: 1, bordered: true, children: [_jsx(Descriptions.Item, { label: "URL Actual", children: window.location.href }), _jsx(Descriptions.Item, { label: "Hash", children: window.location.hash || 'Sin hash' }), _jsx(Descriptions.Item, { label: "Search", children: window.location.search || 'Sin search params' }), _jsx(Descriptions.Item, { label: "Pathname", children: window.location.pathname })] }) })] }) }));
};
export default KeycloakTestPage;
